<template>
  <div>
    <!-- <H1>{{ state.foo }}</H1> -->
  </div>
</template>

<script>
import Vue from 'vue';
// import styled from 'vue-styled-components';

// Within this file, we import components that we want to include.
// Whether that is Styled Components of Vue Components

// const H1 = styled.h1`
//   color: pink;
// `;

export default Vue.extend({
  name: 'Home',
  components: {
    // H1,
  },
});
</script>
